<template>
    <div class="flex flex-column mb-2 mr-6">
        <div class="flex flex-row align-items-center mb-2">
            <div>{{ title }}</div>
            <div class="ml-2 text-gray-500 cursor-pointer">
                <i class="pi pi-question-circle"
                   v-tooltip.bottom="description"></i></div>
        </div>
        <div class="flex flex-row align-items-center">
<!--            <Checkbox type="text" v-model="check" class="p-1 mb-1" />-->
            <input type="checkbox" v-model="check" class="p-1 mb-1">
        </div>

    </div>
</template>

<script>
import Checkbox from 'primevue/checkbox';
import helpers from "@/helpers";
export default{
    components: {Checkbox},
    props:{
        title: String,
        description: String,
        value: [Boolean, String, Number],
    },
    data(){
        return {
            check: false
        }
    },
    watch:{
        value: {
            handler(val){
                this.check = val;
            },
            immediate: true
        },
        check: {
            handler(val){
                this.$emit('input', val);
            }
        }
    },
    methods: {
        ...helpers
    }
}
</script>
